__turbopack_context__.v({
  "h2": "blog-module-scss-module__0fDgmq__h2",
  "h3": "blog-module-scss-module__0fDgmq__h3",
  "imageContainer": "blog-module-scss-module__0fDgmq__imageContainer",
  "item": "blog-module-scss-module__0fDgmq__item",
  "list": "blog-module-scss-module__0fDgmq__list",
});
